﻿<div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
  <h4 class="card-title mb-0 flex-grow-1 text-truncate">

    Contact Requests
  </h4>
  <app-button [outlined]="true" size="sm" (click)="navigateToFullPage()" label="View All" class="flex-shrink-0">
  </app-button>
</div>

<div class="card-body p-3">
  <div *ngIf="viewStatus === ViewStatus.LOADING" class="row g-3">
    <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of [1,2,3,4,5,6]">
      <app-shimmer-loader shape="square" height="180px" borderRadius="0.5rem" width="100%">
      </app-shimmer-loader>
    </div>
  </div>

  <div *ngIf="recentContacts.length > 0 && viewStatus === ViewStatus.READY" class="row g-3">
    <div *ngFor="let contact of recentContacts.slice(0, 6)" class="col-12 col-md-6 col-lg-4">
      <div class="card border h-100" [style.cursor]="'pointer'" (click)="navigateToDetails(contact)">
        <div class="card-body p-3">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <h6 class="card-title mb-0 text-truncate">
              {{ contact.lead | leadName }}
            </h6>
            <span class="badge badge-md" [ngClass]="getStatusBadgeClass(contact.status)">
              {{ getStatusText(contact.status) }}
            </span>
          </div>

          <div class="mb-2">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="small text-muted">Location:</span>
              <span class="badge text-dark">
                {{ getLocationText(contact) }}
              </span>
            </div>

            <div *ngIf="!isAdmin" class="d-flex justify-content-between align-items-center mb-1">
              <span class="small text-muted">Motivation:</span>
              <span class="badge badge-sm" [ngClass]="getMotivationBadgeClass(contact.motivation)">
                {{ getMotivationText(contact.motivation) }}
              </span>
            </div>

            <div *ngIf="isAdmin" class="d-flex justify-content-between align-items-center mb-1">
              <span class="small text-muted">Partner:</span>
              <span class="badge text-dark">
                {{ contact.partner.name || 'N/A' }}
              </span>
            </div>

            <div *ngIf="isAdmin" class="d-flex justify-content-between align-items-center mb-2">
              <span class="small text-muted">Created:</span>
              <span class="small">{{ contact.lead.createdAt ? formatDate(contact.lead.createdAt) : '' }}</span>
            </div>

            <div *ngIf="contact.status === 'ACCEPTED'" class="d-flex justify-content-between align-items-center mb-1">
              <span class="small text-muted">Phone Number:</span>
              <span class="text-dark small">{{ contact.lead.contactInfoRestricted ? hiddenContactLabel : contact.lead.phoneNumber || 'N/A' }}</span>
            </div>

            <div *ngIf="!isAdmin && contact.status === 'PENDING'" class="unlock-button-container">
              <app-button class="w-100" [buttonType]="'success'" [size]="'sm'"
                [label]="'Unlock phone number' | translate" (onClick)="showPhoneNumberConfirmation(contact)"
                (click)="$event.stopPropagation()" [icon]="'lock-open'" [isDisabled]="isWalletDebtExceeded">
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="recentContacts.length === 0 && viewStatus === ViewStatus.READY" class="text-center text-muted py-4">
    <i class="fas fa-inbox fa-2x mb-2"></i>
    <p class="mb-0">No contact requests found</p>
  </div>
</div>

<app-confirmation-modal #confirmationModal (confirmed)="onPhoneNumberConfirmed($event)"
  (dismissed)="onPhoneNumberDismissed()">
</app-confirmation-modal>
